<template>
  <div
    class="box fc-ac-jc"
    :class="{ 'box--active': active, hover: showHover }"
    :style="style"
    @click="select()"
  >
    <slot></slot>
    <div
      class="box__select fr-ac-jc"
      :style="'border-radius:' + selectRadius + 'px 0 '"
      v-if="active && showTick"
    >
      <IconFont name="icon_dagou" :size="12" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, toRefs, computed, inject, watch } from 'vue';
import {} from '@/api/url';
import type { LocalMethods } from '@/utils/localMethod';
import { Navigation, Pagination } from 'swiper/modules';
const modules = [Navigation, Pagination];

const $lm = inject<LocalMethods>('localMethods');

const emit = defineEmits(['click']);

const props = withDefaults(
  defineProps<{
    active: boolean;
    height: number;
    width: number;
    radius?: number;
    showHover?: boolean;
    selectRadius?: boolean;
    showTick?: boolean;
  }>(),
  {
    showTick: () => true,
  }
);

const { active, height, width, radius, showHover, selectRadius, showTick } =
  toRefs(props);

const style = computed(() => {
  return {
    height: height.value + 'px',
    width: width.value + 'px',
    borderRadius: radius.value ? radius.value + 'px' : '20px',
  };
});

const select = () => {
  emit('click');
};

onMounted(() => {});
</script>

<style lang="scss" scoped>
// 基础渐变样式
@mixin gradient($alpha: 0) {
  background: rgba(#fff, 0.25);
  /*background: linear-gradient(
    94deg,
    rgba(160, 101, 255, $alpha) 0%,
    rgba(75, 143, 249, $alpha) 62%,
    rgba(36, 214, 146, $alpha) 100%
  );*/
}

.hover {
  // 悬停状态
  &:hover {
    @include gradient(0.4);
  }
}

.box {
  position: relative;
  cursor: pointer;

  // 默认状态
  @include gradient(0);

  // 激活状态
  &--active {
    @include gradient(1);

    &:hover {
      @include gradient(1);
    }
  }

  &__select {
    width: 24px;
    height: 24px;
    background: var(--bg-color-primary);
    color: var(--text-color-white);
    //background: linear-gradient(135deg, #a065ff 10%, #4b8ff9 50%, #24d692 100%);
    box-shadow: 2px 2px 4px 0px rgba(21, 35, 74, 0.1);
    border-radius: var(--border-radius);
    position: absolute;
    left: 0;
    top: 0;
  }
}
</style>
